import FinanceCalculator from 'components/shared/FinanceCalculator';
import TrustpilotBar from 'components/shared/TrustpilotBar';
import { COPY } from './constants';
import useEnquiryQuoteComplete from './useEnquiryQuoteComplete';

const EnquiryQuoteComplete: React.FunctionComponent = function () {
  const { isLoading, infoWorkTypes, workType, total } =
    useEnquiryQuoteComplete();
  return (
    <div className="flex flex-col w-full mb-auto pt-3">
      <h1 className="mb-6 text-20-24-em md:text-24-28-em text-left">
        {COPY.header}
      </h1>
      <h3 className="text-14-22 md:text-16-24 mb-6">{COPY.body}</h3>
      <h3 className="text-14-22 md:text-16-24 mb-6">{COPY.subbody}</h3>
      <FinanceCalculator
        infoWorkTypes={infoWorkTypes}
        workType={workType}
        isLoading={isLoading}
        initialValue={total}
      />
      <TrustpilotBar wrapperClassName="my-6" />
    </div>
  );
};

export default EnquiryQuoteComplete;
